/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/oneTimeCyberAgentScanMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a OneTimeCyberAgentScan. */
export class OneTimeCyberAgentScan {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a OneTimeCyberAgentScan.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Returns one-time cyberagent scan status data.
   * @summary Returns one-time cyberagent scan status data.
   * @param [options] The optional parameters
   * @returns Promise<Models.OneTimeCyberAgentScanGetStatusDataResponse>
   */
  getStatusData(options?: coreHttp.RequestOptionsBase): Promise<Models.OneTimeCyberAgentScanGetStatusDataResponse>;
  /**
   * @param callback The callback
   */
  getStatusData(callback: coreHttp.ServiceCallback<Models.OneTimeCyberAgentScanStatusData>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getStatusData(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.OneTimeCyberAgentScanStatusData>): void;
  getStatusData(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.OneTimeCyberAgentScanStatusData>, callback?: coreHttp.ServiceCallback<Models.OneTimeCyberAgentScanStatusData>): Promise<Models.OneTimeCyberAgentScanGetStatusDataResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getStatusDataOperationSpec,
      callback) as Promise<Models.OneTimeCyberAgentScanGetStatusDataResponse>;
  }

  /**
   * Performs a one-time cyberagent scan and returns the baseline breaches
   * @summary Performs a one-time cyberagent scan and returns the baseline breaches.
   * @param [options] The optional parameters
   * @returns Promise<Models.OneTimeCyberAgentScanScanAndGetBreachesResponse>
   */
  scanAndGetBreaches(options?: Models.OneTimeCyberAgentScanScanAndGetBreachesOptionalParams): Promise<Models.OneTimeCyberAgentScanScanAndGetBreachesResponse>;
  /**
   * @param callback The callback
   */
  scanAndGetBreaches(callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  scanAndGetBreaches(options: Models.OneTimeCyberAgentScanScanAndGetBreachesOptionalParams, callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  scanAndGetBreaches(options?: Models.OneTimeCyberAgentScanScanAndGetBreachesOptionalParams | coreHttp.ServiceCallback<Models.BreachedDetail[]>, callback?: coreHttp.ServiceCallback<Models.BreachedDetail[]>): Promise<Models.OneTimeCyberAgentScanScanAndGetBreachesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      scanAndGetBreachesOperationSpec,
      callback) as Promise<Models.OneTimeCyberAgentScanScanAndGetBreachesResponse>;
  }

  /**
   * Deletes existing scan.
   * @summary Deletes scan for testing purposes only.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteScan(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  deleteScan(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteScan(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  deleteScan(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      deleteScanOperationSpec,
      callback);
  }

  /**
   * Returns existing breaches.
   * @summary Returns existing breaches.
   * @param [options] The optional parameters
   * @returns Promise<Models.OneTimeCyberAgentScanGetExistingBreachesResponse>
   */
  getExistingBreaches(options?: coreHttp.RequestOptionsBase): Promise<Models.OneTimeCyberAgentScanGetExistingBreachesResponse>;
  /**
   * @param callback The callback
   */
  getExistingBreaches(callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getExistingBreaches(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  getExistingBreaches(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.BreachedDetail[]>, callback?: coreHttp.ServiceCallback<Models.BreachedDetail[]>): Promise<Models.OneTimeCyberAgentScanGetExistingBreachesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getExistingBreachesOperationSpec,
      callback) as Promise<Models.OneTimeCyberAgentScanGetExistingBreachesResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getStatusDataOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/OneTimeCyberAgentScan/status",
  responses: {
    200: {
      bodyMapper: Mappers.OneTimeCyberAgentScanStatusData
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const scanAndGetBreachesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/OneTimeCyberAgentScan/scan",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.OneTimeCyberAgentScanRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachedDetail"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteScanOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/IdentityTheftMonitoring/OneTimeCyberAgentScan/scan",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getExistingBreachesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/OneTimeCyberAgentScan/breaches",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachedDetail"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
